export default {
    methods:{
          cleanTableCollapsed(){
            const itemActivo = document.getElementsByClassName("vs-table__expand__td__content");
            // console.log('itemActivo.length', itemActivo.length);
            for (let index = 0; index < itemActivo.length; index++) {
              itemActivo[index].style = "display:none;";
              // console.log('index:', index); 
            }
          },
          DateFormat(d){
            return d.split('T')[0];
          }

    },
   
  };